// extracted by mini-css-extract-plugin
export var box = "_4p-2";
export var checkboxControl = "_4p-0";
export var checkboxRow = "_4p-a";
export var checked = "_4p-3";
export var descriptionSpacer = "_4p-c";
export var disabled = "_4p-4";
export var icon = "_4p-8";
export var input = "_4p-1";
export var labelSpacer = "_4p-b";
export var large = "_4p-7";
export var medium = "_4p-6";
export var small = "_4p-5";
export var text = "_4p-9";